/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Platinumearned1Inputs */

const id_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum diperoleh`)
};

const ms_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum diperoleh`)
};

const da_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum optjent`)
};

const de_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platin verdient`)
};

const en_us2_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum earned`)
};

const es_es2_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platino obtenido`)
};

const es_mx2_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platino obtenido`)
};

const fil_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakamit ang Platinum`)
};

const fr_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platine obtenu`)
};

const it_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platino ottenuto`)
};

const hu_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina megszerezve`)
};

const nl_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina verdiend`)
};

const no_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum opptjent`)
};

const pl_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdobyto platynę`)
};

const pt_br2_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina conquistada`)
};

const pt_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina obtida`)
};

const ro_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platină obținută`)
};

const fi_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina ansaittu`)
};

const sv_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina intjänad`)
};

const vi_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đạt Bạch kim`)
};

const tr_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platin kazanıldı`)
};

const cs_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získána platina`)
};

const bg_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платина спечелена`)
};

const ru_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платина получена`)
};

const uk_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримано платину`)
};

const ar_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الحصول على بلاتين`)
};

const hi_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लैटिनम प्राप्त`)
};

const th_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ได้รับแพลตตินัม`)
};

const ja_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラチナ獲得`)
};

const zh_cn2_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获得白金成就`)
};

const zh_hant1_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲得白金成就`)
};

const ko_profile_activity_platinumearned1 = /** @type {(inputs: Profile_Activity_Platinumearned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플래티넘 획득`)
};

/**
* | output |
* | --- |
* | "Platinum earned" |
*
* @param {Profile_Activity_Platinumearned1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_platinumearned1 = /** @type {((inputs?: Profile_Activity_Platinumearned1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Platinumearned1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_platinumearned1(inputs)
	if (locale === "ms") return ms_profile_activity_platinumearned1(inputs)
	if (locale === "da") return da_profile_activity_platinumearned1(inputs)
	if (locale === "de") return de_profile_activity_platinumearned1(inputs)
	if (locale === "en-US") return en_us2_profile_activity_platinumearned1(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_platinumearned1(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_platinumearned1(inputs)
	if (locale === "fil") return fil_profile_activity_platinumearned1(inputs)
	if (locale === "fr") return fr_profile_activity_platinumearned1(inputs)
	if (locale === "it") return it_profile_activity_platinumearned1(inputs)
	if (locale === "hu") return hu_profile_activity_platinumearned1(inputs)
	if (locale === "nl") return nl_profile_activity_platinumearned1(inputs)
	if (locale === "no") return no_profile_activity_platinumearned1(inputs)
	if (locale === "pl") return pl_profile_activity_platinumearned1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_platinumearned1(inputs)
	if (locale === "pt") return pt_profile_activity_platinumearned1(inputs)
	if (locale === "ro") return ro_profile_activity_platinumearned1(inputs)
	if (locale === "fi") return fi_profile_activity_platinumearned1(inputs)
	if (locale === "sv") return sv_profile_activity_platinumearned1(inputs)
	if (locale === "vi") return vi_profile_activity_platinumearned1(inputs)
	if (locale === "tr") return tr_profile_activity_platinumearned1(inputs)
	if (locale === "cs") return cs_profile_activity_platinumearned1(inputs)
	if (locale === "bg") return bg_profile_activity_platinumearned1(inputs)
	if (locale === "ru") return ru_profile_activity_platinumearned1(inputs)
	if (locale === "uk") return uk_profile_activity_platinumearned1(inputs)
	if (locale === "ar") return ar_profile_activity_platinumearned1(inputs)
	if (locale === "hi") return hi_profile_activity_platinumearned1(inputs)
	if (locale === "th") return th_profile_activity_platinumearned1(inputs)
	if (locale === "ja") return ja_profile_activity_platinumearned1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_platinumearned1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_platinumearned1(inputs)
	return ko_profile_activity_platinumearned1(inputs)
});
export { profile_activity_platinumearned1 as "profile.activity.platinumEarned" }